module.exports = __webpack_public_path__ + "img/logo_avtomir-new.4c735461.svg";